/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 08.09.2016.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _get from 'lodash/get';

import ShowcaseRelated from '../containers/ShowcaseRelated';

import {GetPackages} from '../actions/collection/actions-collection';

class ShowcaseRelatedRoute extends Component {

  componentWillMount() {
    this.props.GetPackages();
  }

  render() {

    return (
      <ShowcaseRelated assetId={_get(this.props, 'params.assetId', null)} />
    );
  }
}

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({GetPackages}, dispatch);
};

export default connect(() => ({}), mapDispatchToProps)(ShowcaseRelatedRoute);



// WEBPACK FOOTER //
// ./src/routes/related-route.js